export enum TipoForm {
    PUT = 0,
    GET = 1,
    POST = 2,
  }

